fx.ns("desktop.common.photoimport", class PhotoChoices  extends shared.screens.BaseChoiceScreen  //extends fx.components.PopupPanel 
{
    
	constructor(mode)
	{
		super();

        this.showNext = fx.get("mode") == "creating";
        this.showBack = fx.get("mode") == "creating";
        this.mode = fx.get("mode") == "creating" ? "" : "popup";
        
		this._options = Object.assign(this.defaults, mode || {});

        this._bottomText = "";
        this._containerHeight = 500;
	}

    get bottomText()
    {
        return this._bottomText;
    }

    set bottomText(val)
    {
        this._bottomText = val;
    }


    get containerHeight()
    {
        return this._containerHeight;
    }

    set containerHeight(val)
    {
        this._containerHeight = val;
    }

	get defaults()
	{
		return {computer : true, mobile : true, facebook : false, google : true, instagram : false, file : true, albums : true}
	}

	get options()
	{
		return this._options;
	}

	get fileSelector()
	{
		if (!this._fileSelector)
		{
			this._fileSelector = fx.service("MediasUploader").fileSelector;
			this.on("files-selected", this.onFilesSelected, this._fileSelector);
		}
			
		return this._fileSelector;
	}

	get photoExtractor()
	{
		if (!this._photoExtractor)
			this._photoExtractor = fx.service("MediasUploader").photoExtractor;
		
		return this._photoExtractor;
	}

	get pdfSelector()
	{
		if (!this._pdfSelector)
		{
			this._pdfSelector = new fx.components.FileSelector({fileTypes : [".pdf" /*, ".doc", ".docx", ".pptx"*/], multipleSelection: true});
			this.on("files-selected", this._onPdfSelected, this._pdfSelector);
			this.on("files-extension-error", this._onPdfExtensionError, this._pdfSelector);
		}
			
		return this._pdfSelector;
	}

	
	create()
	{
		super.create();

		let box = new fx.components.Box();

		box.addChild(new shared.component.Person(fx.get("assets").photoImportStep1), {width:200, height : 200, top : 0, left : "center"});

		let text = new fx.components.Text({text : fx.text("Sélectionnez vos photos depuis :"), className : "title"});
		box.addChild(text, {height:60, top : 220, left : "center"});

		this.hbox_main = new fx.components.HBox("sources");
        box.addChild(this.hbox_main, {height : 190, left : "center", top : 260});

		if (this._options.computer)
		{
			let computerBox = new fx.components.Box("computer-box");
			this.computerButton = new fx.components.IconButton( {icon: fx.assets.computer, filled : true, className:"computer" } )
			computerBox.addChild( this.computerButton , {width:120, top : 10, left : "center"});
			computerBox.addChild( new fx.components.Text(fx.text("Votre ordinateur")), {width : "100%", height : 20, bottom : 0, left : 0});
			this.hbox_main.addChild(computerBox, {width:150, height: 170});
		}

		if (this._options.mobile)
		{
			let mobileBox = new fx.components.Box("mobile-box");
			this.mobileButton = new fx.components.IconButton( {icon: fx.assets.mobile, filled : false, className:"mobile" } )
			mobileBox.addChild( this.mobileButton , {width:80, top : 30, left : "center"});
			mobileBox.addChild( new fx.components.Text(fx.text("Un mobile")), {width : "100%", height : 20, bottom : 0, left : 0});
			this.hbox_main.addChild(mobileBox, {width:120, height: 170});
		}

		if(this._options.google)
		{
			let googleBox = new fx.components.Box("google-box");
			this.googleButton = new fx.components.IconButton( {icon: fx.assets.google, filled : false, className:"google"} );
			googleBox.addChild( this.googleButton , {width:80, top:30, left : "center" });
			googleBox.addChild( new fx.components.Text(fx.text("Google")), {width : "100%", height : 20, bottom : 0, left : 0});
			this.hbox_main.addChild(googleBox, {width:120, height: 170});
		}

		if(this._options.file || this._options.albums)
        {
			let otherBox = new fx.components.Box("other-box");
			this.otherButton = new fx.components.IconButton( {icon: fx.assets.other, filled : false, className:"other"} );
			otherBox.addChild( this.otherButton, {width:80, top:30, left : "center" });
			otherBox.addChild( new fx.components.Text(fx.text("Autre")), {width : "100%", height : 20, bottom : 0, left : 0});
			this.hbox_main.addChild(otherBox, {width:120, height: 170});
	

            this.hbox_other = new fx.components.HBox("hbox-other");
            this.hbox_other.visibleAtStart = false;
            box.addChild(this.hbox_other, {height : 190, left : "center", top : 260});

            this.backChoiceButton = new fx.components.IconButton({className : "back", icon : fx.assets.previousIcon});
            this.hbox_other.addChild(this.backChoiceButton, {width:80, top: 30});

            if (this._options.file)
            {
                let fileBox = new fx.components.Box("file-box");
                this.fileButton = new fx.components.IconButton( {icon: fx.assets.file, filled : false, className:"file"} );
                fileBox.addChild( this.fileButton, {width:80, top:30, left : "center" });
                fileBox.addChild( new fx.components.Text(fx.text("Fichier PDF")), {width : "100%", height : 20, bottom : 0, left : 0});
                this.hbox_other.addChild(fileBox, {width:120, height: 170});
            }
        
            if (this._options.albums && this.data.account.isRegistered)
            {
                let albumsBox = new fx.components.Box("albums-box");
                this.albumButton = new fx.components.IconButton( {icon: fx.assets.albums, filled : false, className:"albums" } );
                albumsBox.addChild( this.albumButton , {width:80, top:30, left : "center" });
                albumsBox.addChild( new fx.components.Text(fx.text("Vos Creations")), {width : "100%", height : 20, bottom : 0, left : 0});
                this.hbox_other.addChild(albumsBox, {width:120, height: 170});
            }
        }

        if (this._options.instagram || this._options.facebook)
        {
            this.hbox_socialnetworks = new fx.components.HBox("hbox-socialnetworks");
            this.hbox_socialnetworks.visibleAtStart = false;
            box.addChild(this.hbox_socialnetworks, {height : 190, left : "center", top : 260});
            this.backButton2 = new fx.components.IconButton({className : "back", icon : fx.assets.previousIcon});
            this.hbox_socialnetworks.addChild(this.backButton2, {width:80, top: 30});
            
            if (this._options.facebook)
            {
                let facebookBox = new fx.components.Box("facebook-box");
                this.facebookButton = new fx.components.IconButton( {icon: fx.assets.facebook, filled : false, className:"facebook"} );
                facebookBox.addChild( this.facebookButton , {width:80, top:30, left : "center" });
                facebookBox.addChild( new fx.components.Text(fx.text("Facebook")), {width : "100%", height : 20, bottom : 0, left : 0});
                this.hbox_socialnetworks.addChild(facebookBox, {width:120, height: 170});
            }
            
            if (this._options.instagram)
            {
                let instagramBox = new fx.components.Box("instagram-box");
                this.instagramButton = new fx.components.IconButton( {icon: fx.assets.instagram, filled : false, className:"instagram"} ) ;
                instagramBox.addChild( this.instagramButton, {width:80, top:30, left : "center" });
                instagramBox.addChild( new fx.components.Text(fx.text("Instagram")), {width : "100%", height : 20, bottom : 0, left : 0});
                this.hbox_socialnetworks.addChild(instagramBox, {width:120, height: 170});
            }
        }

        if (this.bottomText)
        {
            box.addChild( new fx.components.Text({className : "bottom-text", text : this.bottomText}), { width : "100%", height : "30", bottom : 0, left: 0});
        }

		this.addChild(box, { top : "center", width : "100%", height : this.containerHeight});
	}

	onReady()
	{
		super.onReady();

		if (this.computerButton)
			this.on("click",this.onComputerClick, this.computerButton);

		if (this.mobileButton)
			this.on("click",this.onMobileClick, this.mobileButton);

		if (this.facebookButton)
			this.on("click",this.onFacebookClick, this.facebookButton);

		if (this.instagramButton)
			this.on("click",this.onInstagramClick, this.instagramButton);

		if (this.googleButton)
			this.on("click",this.onGoogleClick, this.googleButton);

		if (this.fileButton)
			this.on("click",this.onFileClick, this.fileButton);

		if (this.albumButton)
			this.on("click",this.onAlbumClick, this.albumButton);

		if (this.socialNetworksButton)
			this.on("click",this.onSocialNetworksClick, this.socialNetworksButton);

		if (this.otherButton)
			this.on("click",this.onOtherClick, this.otherButton);

		if (this.backChoiceButton)
			this.on("click",this.onPreviousClick, this.backChoiceButton);

		if (this.backButton2)
			this.on("click",this.onPreviousClick, this.backButton2);

        this.on("ESCAPE", this.close, fx.keyboard);

		this.fileSelector.fileTypes = [".jpeg", ".jpg", ".png", ".heic"];
	}

    close()
    {
        this.data.event("show-editor");
    }

	onPreviousClick()
    {
		this.hbox_main.removeClass("fadeOutLeft");
		this.hbox_main.addClass("fadeInRight");
        this.hbox_main.show();

        if (this.hbox_socialnetworks)
        {
            this.hbox_socialnetworks.removeClass("fadeInLeft");
            this.hbox_socialnetworks.addClass("fadeOutRight");
            this.hbox_socialnetworks.hide();
        }

        if (this.hbox_other)
        {
            this.hbox_other.removeClass("fadeInLeft");
            this.hbox_other.addClass("fadeOutRight");
            this.hbox_other.hide();
        }
	}

	onSocialNetworksClick()
	{
		this.hbox_main.removeClass("fadeInRight");
		this.hbox_main.addClass("fadeOutLeft");
        this.hbox_main.hide();

        if (this.hbox_socialnetworks)
        {
            this.hbox_socialnetworks.removeClass("fadeOutLeft");
            this.hbox_socialnetworks.addClass("fadeInLeft");
            this.hbox_socialnetworks.show();
            this.hbox_socialnetworks.viewport({height : 190, left : "center", top : 260});
        }

        if (this.hbox_other)
		    this.hbox_other.hide();
	}

	onOtherClick()
	{
		this.hbox_main.removeClass("fadeInRight");
		this.hbox_main.addClass("fadeOutLeft");
		this.hbox_main.hide();

        if (this.hbox_socialnetworks)
		    this.hbox_socialnetworks.hide();

        if (this.hbox_other)
        {
            this.hbox_other.removeClass("fadeOutLeft");
            this.hbox_other.addClass("fadeInLeft");
            this.hbox_other.show();
            this.hbox_other.viewport({height : 190, left : "center", top : 260});
        }
	}

	// photo import
	onComputerClick()
	{
		// The first time, we show a popup with more explanations
		if (!fx.get("selectFilesAlert") && fx.get("app") != "config") 
        {
			this._noticeSelectPopup = new shared.popups.NoticeSelectFiles();
			this.popup(this._noticeSelectPopup);
			this.on("closed", this.onComputerClick, this._noticeSelectPopup);
            fx.set("selectFilesAlert", true);
		}
		else
			this.fileSelector.selectFiles();
	}

	onMobileClick()
	{
		this.data.event("import-mobile");
	}

	onFacebookClick()
	{
		this.data.event("import-facebook");
	}

	onInstagramClick()
	{
		this.data.event("import-instagram");
	}
	
	onGoogleClick()
	{
		this.data.event("import-google");
	}

	onFileClick()
	{
		// show notice popup and wait for event == notice-select-pdf-closed
		this.pdfSelector.selectFiles();
	}

	onAlbumClick()
	{
		this.data.event("import-albums");
	}

	destroy()
	{
		super.destroy();

		this._fileSelector = null;
		this._fileExtractor = null;
	}

	onFilesSelected(event)
	{
		this.data.event("photos-files-selected");
	}

	_onPdfSelected(event)
	{
		this.data.event("show-editor");
		fx.service("PdfUploader").upload(event.detail);
	}

	_onPdfExtensionError(event)
	{
		this.popup(new common.popups.WrongFilePopup());
	}

});